<template>
  <div class="enroll">
    <div class="header">
      报名信息填写
    </div>
    <div class="form">
      <my_input v-for="f in forms" :key="f.label" :placeholder="f.placeholder" v-model="fm[f.label]" :type="f.type" :title="f.title"></my_input>
      <div class="MyInput">
        <label>所在年级</label>
        <select v-model="fm.grade">
          <option v-for="g in gradeOptions" :key="g.label" :value="g.label">{{g.label}}</option>
        </select>
      </div>
      <div class="MyInput">
        <label>手机号</label>
        <span>{{user.phone}}</span>
      </div>
      <div class="button">
        <my_button @click.native="submit" value="提交" :disable="disableButton"></my_button>
      </div>
      <div class="tips">
        提示：选手个人信息仅做活动期间个人信息确认使用，活动组委会将会严格保密参加活动选手个人信息。
        报名成功后，您需要在2025年11月30号之前开始并在一个小时内完成初赛考试。
      </div>
    </div>
  </div>
</template>

<script>
import MyInput from '@/components/Input.vue'
 import MyButton from '@/components/Button.vue'
export default {
  name: 'EnrollInfo',

  data () {
    return {
      fm: {
        realname: '',
        school: '',
        grade: '',
      },
      forms: [
        { title: '姓名', label: 'realname', placeholder: '请输入姓名', type: 'text' },
        { title: '所在学校', label: 'school', placeholder: '请输入学校', type: 'text' },
      ],
      gradeOptions: [
        {label:'小学五年级',},
        {label:'小学六年级',},
        {label:'初中一年级',},
        {label:'初中二年级',},
        {label:'初中三年级',},
        {label:'高中一年级',},
        {label:'高中二年级',},
        {label:'高中三年级',},
        {label:'大学一年级',},
        {label:'大学二年级',},
        {label:'大学三年级',},
      ]

    }
  },
  computed: {
    timeSet () {
      return this.$store.state.enroll.timeSets
    },
    user() {
      return this.$store.state.auth.user || {}
    },
    disableButton () {
      return !(this.fm.realname && this.fm.school && this.fm.grade)
    }
  },
  methods: {
    submit() {
       let data = new FormData();
       data.set('realname', this.fm.realname);
       data.set('organization', this.fm.school)
       data.set('grade', this.fm.grade);

       this.$http.post('/api/user/enroll', data)
           .then(res => {
             this.tip = '报名成功'
             this.tips=true;
             /* this.$store.commit("SUCCESS_ENROLLED");*/
             window.location.reload();
           })

    }
  },
  components: {
    my_input: MyInput,
    my_button: MyButton,
  }
}
</script>
<style scoped>
.header{
  text-align: center;
  font-size: 22px;
  font-weight: bold;
  margin-bottom: 20px;
}
.enroll {
  width: 40%;
  margin-left: auto;
  margin-right: auto;
  padding: 30px 50px;
  border: 1px solid rgb(187, 187, 187);
}
.form {

}
 .MyInput {
   width: 100%;
   display: flex;
   line-height: 1.35vw;
   margin-bottom: 10px;
 }

 .MyInput > label {
   display: flex;
   align-items: center;
   justify-content: flex-end;
   font-size: 0.83vw;
   flex-basis: 100px;
   margin-right: 30px;
 }
.MyInput > span {
  display: flex;
  align-items: center;
}
 .MyInput > select, .MyInput > span {
   width: 10em;
   font-size: 1vw;
   line-height: 1.35vw !important;
   height: 2.8vw;
   box-sizing: border-box;
   padding-left: 0.78vw;
 }



</style>